import styled from "styled-components";

export const Container = styled.div`
    background: #F7F8FC;    
`